export default __webpack_public_path__ + "static/media/sports-card-bg.fd599f6c.svg";